import { render, staticRenderFns } from "./conversation.vue?vue&type=template&id=7934dfd3&"
import script from "./conversation.js?vue&type=script&lang=js&"
export * from "./conversation.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports